import React from 'react';
import PropTypes from 'prop-types';

import AutoExpandOnError from './AutoExpandOnError';
import {
  ShowHideComponentsButtonBox,
  ShowHideComponentsButton,
  AngleDown,
} from './styles';

const propTypes = {
  setAreComponentsRendered: PropTypes.func.isRequired,
  namespace: PropTypes.string,
  isRequired: PropTypes.bool,
  countryCodeFieldName: PropTypes.string,
};

const defaultProps = {
  namespace: null,
  isRequired: true,
  countryCodeFieldName: null,
};

function ShowComponentsButton({ setAreComponentsRendered, namespace, isRequired, countryCodeFieldName }) {
  return (
    <>
      <AutoExpandOnError
        namespace={namespace}
        setAreComponentsRendered={setAreComponentsRendered}
        isRequired={isRequired}
        countryCodeFieldName={countryCodeFieldName}
      />
      <ShowHideComponentsButtonBox width={[1, 1, 1]}>
        <ShowHideComponentsButton onClick={() => setAreComponentsRendered(true)}>
          Show Components
          <AngleDown />
        </ShowHideComponentsButton>
      </ShowHideComponentsButtonBox>
    </>
  );
}

ShowComponentsButton.propTypes = propTypes;
ShowComponentsButton.defaultProps = defaultProps;

export default ShowComponentsButton;
